/* eslint-disable jsx-a11y/alt-text */
import React ,{useEffect,useState}from "react";
import { PayCircleOutlined, AlipayCircleOutlined, WechatOutlined } from "@ant-design/icons";
import { Outlet, useNavigate } from "react-router-dom";
import { Layout, Menu, Space, Popover, Button, Avatar, Modal, Radio, Input, message } from 'antd';
import {
  HomeOutlined,
  FileSearchOutlined,
  ShoppingOutlined,
  UserOutlined,
  PropertySafetyOutlined,
  LogoutOutlined,
  DownOutlined,
  SendOutlined,
  ApartmentOutlined,
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  DownloadOutlined,
  GlobalOutlined,
  BookOutlined
} from "@ant-design/icons";
import "./index.css";
import { post } from "../http/index";
import Logo from '../logo.png';
import QrCodePopUp from '../components/qrcode-popup';


const { Header, Sider, Content } = Layout;

const LayoutBox = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');
  const [demenu, setDemenu] = useState(window.location.pathname);
  const [czVisible, setCzVisible] = useState(false);
  const [payWay, setPayWay] = useState('alipay');
  const [chargeCount, setChargeCount] = useState('20');
  const [conte, setConte] = useState(false);
  const [vxPay, setVxPay] = useState(false);
  const [qrCodeVisible, setQrCodeVisible] = useState(false);
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const [rechargeLoading, setRechargeLoading] = useState(false);


  const content = (
    <Space direction="vertical" size="middle">
      <Button type="text" onClick={()=>goToMyCenter()} icon={<UserOutlined />}>
        个人中心
      </Button>
      <Button type="text" onClick={()=>handleLogout()} icon={<LogoutOutlined />}>
        退出登录
      </Button>
    </Space>
  );
  const goToMyCenter = ()=>{
    navigate('/my-center');
  }

  const handleLogout = () => {
    navigate('/');
    localStorage.clear()
  };
  function getItem(label, key, icon, children, type) {
    return {
      key,
      icon,
      children,
      label,
      type,
    };
  }

  const items = [
    getItem("首页", "/home", <HomeOutlined style={{ color: "#1890ff" }} />),
    getItem(
      <span style={{fontSize: '12px', paddingLeft: '8px'}}>订阅</span>,
      "g1",
      null,
      [
        getItem(
          "我的节点",
          "/my-node",
          <ApartmentOutlined style={{ color: "#1890ff" }} />
        ),
        getItem(
          "购买节点",
          "/buy-node",
          <ShoppingOutlined style={{ color: "#1890ff" }} />
        ),
      ],
      "group"
    ),
    getItem(
      <span style={{fontSize: '12px', paddingLeft: '8px'}}>财务</span>,
      "g2",
      null,
      [
        getItem(
          "我的订单",
          "/my-order",
          <FileSearchOutlined style={{ color: "#1890ff" }} />
        ),
        getItem(
          "我的充值",
          "/my-recharge",
          <PropertySafetyOutlined style={{ color: "#1890ff" }} />
        ),
      ],
      "group"
    ),
    getItem(
      <span style={{fontSize: '12px', paddingLeft: '8px'}}>用户</span>,
      "g3",
      null,
      [
        getItem(
          "个人中心",
          "/my-center",
          <UserOutlined style={{ color: "#1890ff" }} />
        ),
        getItem(
          "推广返利",
          "/my-spread",
          <SendOutlined style={{ color: "#1890ff" }} />
        ),
      ],
      "group"
    ),
  ];

  const onClick = (e) => {
    navigate(e.key);
    setDemenu(e.key);
  };

  const fetchData = async () => {
    const { data } = await post('api/account/my_profile');
    setUserName(data.data.username);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [collapsed, setCollapsed] = useState(false);

  const handlePayWayChange = (e) => { setPayWay(e.target.value); };
  const handleChargeCount = (e) => {
    if (e.target.value === "自定义") { setConte(true); }
    else { setConte(false); setChargeCount(e.target.value); }
  };
  const handleChargeCount01 = (e) => { setChargeCount(e.target.value); };
  const handleScanQrCode = async () => {
    const reqParm = { mode: payWay, money: +chargeCount };
    setRechargeLoading(true);
    const res = await post("api/account/pay", reqParm);
    if (res.code === 0) { Modal.warning({ content: res.msg }); }
    else { setQrCodeVisible(true); setQrCodeUrl(res.data.img); setCzVisible(false); }
    setRechargeLoading(false);
  };
  const handleQrCode = () => { setQrCodeVisible(false); };
  const getPayPopTitle = () => { return payWay === "wechatpay" ? "微信" : "支付宝"; };

  return (
    <>
      <Layout>
        <Header
          style={{
            background: 'linear-gradient(90deg, #1890ff 0%, #667eea 100%)',
            padding: '0 25px 0 0',
            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
          }}>
          <div className='header-box'>
            <div className='logo' style={{cursor: 'pointer'}} onClick={() => navigate('/home')}>
              <img
                src={Logo}
                width='35px'
              />
              <span
                style={{
                  fontSize: '14px',
                  fontWeight: 'bold',
                  paddingLeft: '10px',
                }}>
                掘金加速
              </span>
            </div>
            {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
            className: 'trigger',
            onClick: () => setCollapsed(!collapsed),
          })}
            <Button
              className="header-recharge-btn"
              type="primary"
              icon={<PayCircleOutlined />}
              onClick={() => setCzVisible(true)}
            >
              立即充值
            </Button>
            <div className="header-qq">
              <span className="header-qq-label">售后QQ:</span>
              <span className="header-qq-number">3039993</span>
            </div>
            <a
              className="header-download-btn"
              href="https://down.lhip.cc/ym/YouMiIp2026.zip"
              target="_blank"
              rel="noopener noreferrer"
            >
              <DownloadOutlined />
              有米下载
            </a>
            <a
              className="header-iplc-btn"
              href="http://jiasu.lhip.cc"
              target="_blank"
              rel="noopener noreferrer"
            >
              <GlobalOutlined />
              IPLC
            </a>
            <a
              className="header-tutorial-btn"
              href="https://web.lhip.cc/ym.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              <BookOutlined />
              有米详细教程
            </a>
            <Popover placement='bottom' content={content} trigger='hover'>
              <div className='user'>
                <div className="user-avatar-wrap">
                  <Avatar
                    className="user-avatar"
                    style={{
                      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 50%, #4facfe 100%)',
                      marginRight: '10px',
                      boxShadow: '0 2px 8px rgba(240, 147, 251, 0.4)',
                    }}
                  >
                    {userName ? userName.charAt(0).toUpperCase() : 'U'}
                  </Avatar>
                  <span className="user-name-text">{userName}</span>
                </div>
                <DownOutlined style={{ paddingLeft: '10px' }} />
              </div>
            </Popover>
          </div>
        </Header>
        <Layout className='main'>
          <Sider className='menu-style' trigger={null} collapsible collapsed={collapsed}>
            <Menu
              style={{ borderRight: '0px' }}
              defaultSelectedKeys={[demenu]}
              mode='inline'
              onClick={onClick}
              items={items}
            />
          </Sider>
          <Content
            style={{
              minWidth: '798px',
              padding: '15px',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}>
            <Outlet />
          </Content>
        </Layout>
      </Layout>

      <Modal title="充值" centered visible={czVisible} onOk={handleScanQrCode} onCancel={() => setCzVisible(false)} width={550} okText="确认" cancelText="取消" confirmLoading={rechargeLoading}>
        <div className="reBox">
          <div className="reName">充值金额</div>
          <div className="reList">
            <Radio.Group defaultValue="20" onChange={handleChargeCount}>
              <Radio.Button value="20" className="reNum01">¥ 20</Radio.Button>
              <Radio.Button value="50" className="reNum01">¥ 50</Radio.Button>
              <Radio.Button value="100" className="reNum01">¥ 100</Radio.Button>
              <Radio.Button value="200" className="reNum01">¥ 200</Radio.Button>
              <Radio.Button value="500" className="reNum01">¥ 500</Radio.Button>
              <Radio.Button value="自定义" className="reNum02">自定义</Radio.Button>
            </Radio.Group>
            {conte && <Input style={{marginTop:"-25px",width:"150px",marginBottom:"30px"}} value={chargeCount} onChange={handleChargeCount01} placeholder="请输入充值金额" />}
          </div>
        </div>
        <div className="reBox" style={{paddingTop:"0"}}>
          <div className="reName">支付方式</div>
          <div className="reList">
            <Radio.Group defaultValue="alipay" onChange={handlePayWayChange}>
              <Radio.Button value="alipay" className="reNum02" style={{backgroundColor:vxPay?"white":"#1577FF",color:vxPay?"":"white"}} onClick={()=>setVxPay(false)}><AlipayCircleOutlined style={{paddingRight:"5px"}}/>支付宝</Radio.Button>
              <Radio.Button value="wechatpay" className="reNum02" style={{backgroundColor:vxPay?"#2CAE67":"white",color:vxPay?"white":""}} onClick={()=>setVxPay(true)}><WechatOutlined style={{paddingRight:"5px"}}/>微 信</Radio.Button>
            </Radio.Group>
          </div>
        </div>
      </Modal>

      <QrCodePopUp title={`请用${getPayPopTitle()}扫描二维码`} qrCodeVisible={qrCodeVisible} handleScanQrCode={handleQrCode} handleCancelQrCode={()=>setQrCodeVisible(false)} qrCodeUrl={qrCodeUrl} closable={true}></QrCodePopUp>
    </>
  );
};

export default LayoutBox;
